import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../layouts/PageTitle";
import { useTranslation } from "react-i18next";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import { testSmtpSettings } from "../../../store/custom-actions/settings-actions/smtp/TestSmtpSettingsSlicer";
import SubmitButton from "../../components/ui/SubmitButton";
import FormField from "../../components/ui/FormField";

function TestSmtpSettingsForm() {
  const { t } = useTranslation();
  const { loading: submitLoading } = useSelector(
    (state) => state.testSmtpSettingsSlicer
  );
  const dispatch = useDispatch();
  const [messageContent, setMessageContent] = useState("");
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const testFields = [
    { label: "Email", name: "email", required: true, type: "email" },
    { label: "Subject", name: "subject", required: true },
  ];

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("email", data.email);
    formData.append("subject", data.subject);
    formData.append("message", messageContent);
    
    const result = await dispatch(testSmtpSettings(formData));
    if (result.payload?.success) {
      reset();
      setMessageContent("");
      toast.success(t(result.payload.message), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
    const colors = [
        '#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff',
        '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff',
        '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff',
        '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2',
        '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466',
        '#000000', '#990000', '#b26b00', '#b2b200', '#005c00', '#003399', '#592966'
    ];
  const modules = {
    toolbar: {
      container: [
        [{"color": colors}],
        [{ 'background': colors }],
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['link', "video"],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['clean']
      ],
    }
  };
  return (
    <>
      <PageTitle
        motherMenu={"Settings"}
        activeMenu={"Test SMTP Settings"}
        customClasses={"mb-0"}
      />
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <form id="submit-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="p-2 mb-3 mt-0">
              <SubmitButton
                isLoading={submitLoading}
                form="submit-form"
              />
            </div>

            <div className="card">
              <h5 className="card-title p-4">{t("Test SMTP Settings")}</h5>
              <div className="card-body">
                <div className="row">
                  {testFields.map(({ label, name, required, type }) => (
                    <div className="col-md-6" key={name}>
                      <FormField
                        label={label}
                        name={name}
                        register={register}
                        required={required}
                        errors={errors}
                        type={type || "text"}
                      />
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="col-12">
                    <label className="form-label">
                      <i className="fa-solid fa-envelope mr-1"></i>
                      {t("Message")}
                    </label>
                    <ReactQuill
                      modules={modules}
                      className="p-0 border-none outline-none form-control bg-white mt-3"
                      value={messageContent}
                      theme="snow"
                      onChange={(content) => setMessageContent(content)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}


export default TestSmtpSettingsForm;